import React, { useState } from 'react'
import './Home.css'
import Carousal from 'react-bootstrap/Carousel';
import image1 from './images/book1.jpg';
import image2 from './images/book2.jpg';
import image3 from './images/book3.jpg';

const data =[
  {
    image: image1,
    caption: "Time Shelter",
    description: `Georgi Gospodino Translated by Angela Rodel`
  },
  {
    image: image2,
    caption: "Is Mother Dead",
    description: "Vigdis Hjorth Translated by Charlotte Barslund"
  },
  {
    image: image3,
    caption: "The Ultimate Vegan Breakfast Book",
    description: "80 Mouthwatering Plant-Based Recipes You' Add to Wishlist. QUICK ADD"
  }
]

function Home() {
  const [index, setIndex] = useState(0);
  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  }
  return (
    <div>
      <Carousal activeIndex={index} onSelect={handleSelect}>
        {data.map((slide, i) => {
          return (
            <Carousal.Item> 
              <img className='d-block w-100' height="645px" src={slide.image} alt="slider image" />
              <Carousal.Caption>
                <h3>{slide.caption}</h3>
                <p>{slide.description}</p>
              </Carousal.Caption>
            </Carousal.Item>
          )
        })}
      </Carousal>
    </div>
  )
}

export default Home;